import { currencyType } from "../../constant";



const currencyReducer = (state = false, action) => {
    switch (action.type) {
        case currencyType.FETCH_CURRENCY:
            return action.payload;
        default:
            return state;
    }
}
export default currencyReducer